import { render, staticRenderFns } from "./HolidayAndClosedDays.vue?vue&type=template&id=70834776&scoped=true&"
import script from "./HolidayAndClosedDays.vue?vue&type=script&lang=js&"
export * from "./HolidayAndClosedDays.vue?vue&type=script&lang=js&"
import style0 from "./HolidayAndClosedDays.vue?vue&type=style&index=0&id=70834776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70834776",
  null
  
)

export default component.exports